import { Icon } from '@iconify/react';
import { IconButton, Tooltip } from '@mui/material';
import { InputProps } from 'interfaces/InputProps';
import { useState } from 'react';

// containerClass
// flex items-center justify-between gap-2 py-5 px-8
// containerClass
// inputClassName

const Input: React.FC<InputProps> = ({
  inputClass,
  containerClass,
  labelClass,
  help,
  helperText,
  label,
  min,
  max,
  name,
  value,
  placeholder,
  type,
  required,
  minLength,
  maxLength,
  showOrHidePassword,
  onChange,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className={`px-4 py-2 ${containerClass}`}>
      {label && (
        <label
          htmlFor={name}
          className={`block text-[0.813rem] font-semibold text-black  ${labelClass}`}
        >
          {label}
          {required && (
            <span className="text-sm text-red-500 lg:text-base 2xl:text-lg">
              *
            </span>
          )}
        </label>
      )}
      <div className="relative flex w-full items-center gap-2">
        {required ? (
          <input
            onChange={onChange}
            value={value}
            required
            id={name}
            name={name}
            min={min}
            max={max}
            type={
              showOrHidePassword ? (showPassword ? 'text' : 'password') : type
            }
            placeholder={placeholder}
            minLength={minLength}
            maxLength={maxLength}
            className={`w-full rounded-md border border-gray-300 bg-transparent p-3  text-[0.813rem] ${inputClass}`}
            {...rest}
          />
        ) : (
          <input
            onChange={onChange}
            value={value}
            id={name}
            name={name}
            min={min}
            max={max}
            type={
              showOrHidePassword ? (showPassword ? 'text' : 'password') : type
            }
            placeholder={placeholder}
            minLength={minLength}
            maxLength={maxLength}
            className={`w-full rounded-md border border-gray-300 bg-transparent p-3 text-base ${inputClass}`}
            {...rest}
          />
        )}
        {help && (
          <div className="flex w-2/12 items-center gap-2">
            <Tooltip title={helperText || ''}>
              <IconButton>
                <img src="/assets/icons/helpIcon.svg" alt="help" />
              </IconButton>
            </Tooltip>
          </div>
        )}
        {showOrHidePassword && (
          <div
            onClick={() => setShowPassword(!showPassword)}
            className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3 text-xl leading-5"
          >
            {showPassword ? <Icon icon="ci:show" /> : <Icon icon="ci:hide" />}
          </div>
        )}
      </div>
    </div>
  );
};

export default Input;
